export default __webpack_public_path__ + "static/media/chevron-left-double.727a10d6.svg";